import { createRouter, createWebHistory } from 'vue-router';
const Home = () => import('@/views/Home.vue');
const Resources = () => import('@/views/Resources.vue');
const Map = () => import('@/views/Map.vue');
const LayerDetails = () => import('@/views/LayerDetails.vue');
const ExternalResourceDetails = () => import('@/views/ExternalResourceLayerDetails.vue');
export var RouteNames;
(function (RouteNames) {
    RouteNames["Home"] = "Home";
    RouteNames["Resources"] = "Resources";
    RouteNames["Layers"] = "Item Details";
    RouteNames["Map"] = "Map Explorer";
})(RouteNames || (RouteNames = {}));
const routes = [
    {
        path: '/',
        name: RouteNames.Home,
        component: Home,
        meta: {
            layout: 'Default',
        },
    },
    {
        path: '/' + RouteNames.Resources,
        name: RouteNames.Resources,
        component: Resources,
        meta: {
            layout: 'ListViewLayout',
        },
    },
    {
        path: '/layers/:id',
        name: RouteNames.Layers,
        component: LayerDetails,
        meta: {
            layout: 'Default',
        },
    },
    {
        path: '/applications/:id',
        name: 'externalResource',
        component: ExternalResourceDetails,
        meta: {
            layout: 'Default',
        },
    },
    {
        path: '/notebooks/:id',
        name: 'notebooksResource',
        component: ExternalResourceDetails,
        meta: {
            layout: 'Default',
        },
    },
    {
        path: '/Map',
        name: RouteNames.Map,
        component: Map,
        meta: {
            layout: 'MapLayout',
        },
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
export default router;
